module.exports = __webpack_public_path__ + "img/OurStory_Img1.229181e8.jpg";